(function ($) {

'use strict';

	/**
	 * Change the html of the selected elements to an envelope character and 
	 * set the current text to the title attribute.
	 * @returns {undefined}
	 */
	$.fn.showEnvelope = function () {
		$(this).each(function () {
			if ($(this).text().length > 0) {
				$(this).attr('title', $(this).text())
						.addClass('mailicon')
						.html('&#x2709;');
			}
		});
	};
	
	$.fn.showPhone = function () {
		$(this).each(function(){
			if ($(this).text().length > 0) {
				$(this).attr('title', $(this).text())
						.addClass('phoneicon')
						.html('&#x2706;');
			}
		});
	};

}(jQuery));